module.exports = __webpack_public_path__ + "img/icons8-waypoint-map copy.a487ef66.svg";